import store from '@/store/vuex'
import { Module, VuexModule, Mutation, getModule } from "vuex-module-decorators";

const CRM_BONUS_STORAGE = 'CRM_BONUS_STORAGE'

export interface DadosCrmBonus {
	requestHash: string | null
	userIdNoCrm: string | null
	pinCrmValidado: boolean
	usouPinMaster: boolean
	statusPluginCrmBonus: boolean
	campanha: string | null
	crmBonusIds: string[]
	cashbackAplicado: number
	bloquearUsoCrmBonus: boolean
  }
  
const DEFAULT_STATE: DadosCrmBonus = {
	requestHash: null,
	userIdNoCrm: null,
	pinCrmValidado: false,
	usouPinMaster: false,
	statusPluginCrmBonus: false,
	campanha: null,
	crmBonusIds: [],
	cashbackAplicado: 0,
	bloquearUsoCrmBonus: false,
}

function salvarNoLocalStorage(state: DadosCrmBonus) {
	localStorage.setItem(CRM_BONUS_STORAGE, JSON.stringify(state))
}
  
function lerDoLocalStorage(): DadosCrmBonus {
	const raw = localStorage.getItem(CRM_BONUS_STORAGE)
	return raw ? JSON.parse(raw) : DEFAULT_STATE
}

@Module({
	name: "CrmBonusStore",
	namespaced: true,
	dynamic: true,
	store,
})
export default class CrmBonusStore extends VuexModule {
	dados: DadosCrmBonus = lerDoLocalStorage()

	@Mutation
	setDados(parcial: Partial<DadosCrmBonus>) {
		this.dados = { ...this.dados, ...parcial } 
		salvarNoLocalStorage(this.dados)
	}
  
	@Mutation
	resetar() {
		this.dados = { ...DEFAULT_STATE }
		salvarNoLocalStorage(this.dados)
	}
}

export const CrmBonusModule = getModule(CrmBonusStore)
